import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ToggleInput, { ToggleInputProps } from './ToggleInput';

type ControlledToggleInputProps = {
  name: string;
} & ToggleInputProps;

const ControlledToggleInput = (props: ControlledToggleInputProps) => {
  const { name, ...rest } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      defaultValue={false}
      control={control}
      render={({ field: { onChange } }) => {
        return <ToggleInput {...rest} onChange={onChange}/>;
      }}
    />
  );
};

export default ControlledToggleInput;
